import store from '../../store';
import api from '../../services/api';
import { Creators } from '../ducks/rfb_enterprise';
import { call, put } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';
import { createRunningNotification } from '../../utils/notification';
import { captureSentryException } from '../../utils';

export function* getRfbEnterprises({ filter }) {
  let newFilter = { ...filter };
  let errorMsg = 'Falha ao listar leads';

  try {
    if (filter && filter.is_download) {
      errorMsg = 'Falha ao enviar por e-mail';
      newFilter = {
        ...newFilter,
        firebase_notification_key: yield createRunningNotification({ title: 'Leads' })
      };
    }

    yield put(Creators.rfbEnterpriseRequest());
    const response = yield call(api.post, 'rfb-enterprise', newFilter);

    if (filter && filter.is_download) {
      yield put(Creators.rfbEnterpriseSuccess(store.getState().rfb_enterprise.data));
    } else {
      yield put(Creators.rfbEnterpriseSuccess(response.data));
    }

  } catch (err) {
    yield captureSentryException(err, newFilter);
    yield put(Creators.rfbEnterpriseError({ err }));
    yield put(toastrActions.add({
      type: 'error',
      title: 'Erro',
      message: errorMsg
    }));
  }
}